import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconHome",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(a, t, i, _, f, e) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: n([e.iconSizeClass, "d-icon d-icon--home"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Home",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.693.605a.5.5 0 0 1 .614 0l4.5 3.5A.5.5 0 0 1 11 4.5V10a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 10V4.5a.5.5 0 0 1 .193-.395l4.5-3.5ZM5 10.5h2v-4H5v4Zm3 0V6a.5.5 0 0 0-.5-.5h-3A.5.5 0 0 0 4 6v4.5H2.5A.5.5 0 0 1 2 10V4.745l4-3.112 4 3.112V10a.5.5 0 0 1-.5.5H8Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=home.js.map
